import { Button, Col, Form, Input, InputNumber, Row, notification } from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";

const LogisticsClient = ({ match, history }) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getClient();
	}, []);

	const getClient = async () => {
		const url = api + "/logistics/client/get/" + match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				setInitialValues({
					...initialValues,
					name: data.payload.name,
					latitude: data.payload.latitude,
					longitude: data.payload.longitude,
					address: data.payload.address,
				});
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingForm(false);
		} catch (err) {
			setLoadingForm(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to get destination"
			);
			console.error(err.message);
			return null;
		}
	};

	const updateClient = async (data) => {
		const client = {
			name: data.name,
			latitude: data.latitude,
			longitude: data.longitude,
			address: data.address,
		};

		try {
			let url = api + "/logistics/client/update/" + match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, client);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					history.push("/logistics/destination/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to update destination"
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		updateClient(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>{" "}
					</Col>
					<Col span={24}>
						<Form.Item label="Address" name="address">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Latitude"
							name="latitude"
							rules={[
								{
									required: true,
									message: "Please fill latitude",
								},
							]}
						>
							<InputNumber style={{ width: "100%" }} size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Longitude"
							name="longitude"
							rules={[
								{
									required: true,
									message: "Please fill longitude",
								},
							]}
						>
							<InputNumber style={{ width: "100%" }} size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							size="large"
							loading={loading}
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Logistics Client"
			description="Edit Logistics Client"
			type="small"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default LogisticsClient;
